import { type AxiosResponse } from "axios"
import { type IUserSettings } from "@/interfaces/api/user-settings.interface"
import { BaseRepository } from "@/repositories/base-repository"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"

export class UserSettingsRepository extends BaseRepository<IUserSettings> {
  protected resourcePath = "auth/user-settings"

  /*
    This class implementation deviates from the classic BaseRepository derivatives because we use the
    currently authenticated user to get and update user settings.
    */

  public async get(/* Note absence of id param */): Promise<AxiosResponse<IUserSettings>> {
    return await new HTTPRequestBuilder(HTTPMethods.GET, `${this.resourcePath}/`).build().execute()
  }

  public async user_update(
    /* Note absence of id param */ item: IUserSettings
  ): Promise<AxiosResponse<IUserSettings>> {
    return await new HTTPRequestBuilder(HTTPMethods.PUT, `${this.resourcePath}/`)
      .setData(item)
      .build()
      .execute()
  }
}
